export interface AvailableOffersState {
  // Chave: variationUuid, Valor: array de MSISDNs disponíveis para a variation
  msisdnsByVariation: Record<string, string[]>;

  // Response original do getAvailableOffers
  rawResponse: {
    avaliableMsisdnsForOffers: Record<string, string[]>;
  } | null;

  loading: boolean;
  error: string | null;
  lastUpdated: number | null;
}

export const initialState: AvailableOffersState = {
  msisdnsByVariation: {},
  rawResponse: null,
  loading: false,
  error: null,
  lastUpdated: null,
};

